import { ChatResponse } from '../chat-response.model';

export class TableAdapter implements ChatResponse {
  getFormattedResponse(data): Record<string, any> {
    return {
      type: 'table',
      content: {
        title: data.parameters.title,
        columns: data.parameters.columns,
        rows: data.parameters.rows,
        summary: data.summary,
      },
    };
  }
}
